<template>
  <BaseEditorSection
    :config="lessonPlanConfig"
    :is-edit-form="isEditForm"
    @tabs-updated="(...args) => $emit('tabs-updated', ...args)"
    ref="baseEditor"
  />
</template>

<script setup>
/* eslint-disable no-unused-vars */
import BaseEditorSection from "../shared/BaseEditorSection.vue";
import { ref, defineEmits, defineExpose, defineProps } from "vue";
import { CATEGORY_TYPES } from "@/utils/constants";

const props = defineProps({
  isEditForm: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["tabs-updated"]);

const baseEditor = ref(null);

const lessonPlanConfig = {
  enableAssessment: true,
  enableAttachments: true,
  enableSlides: true,
  enableMaterials: true,
  moduleTabLabel: "Module",
  initialPlaceholder: "Start writing your lesson plan here...",
  defaultTabStructure: "lesson-plan",
  moduleType: CATEGORY_TYPES.LessonPlan,
};

// Expose all methods from the base editor
defineExpose({
  updateFromParent: (...args) => baseEditor.value?.updateFromParent(...args),
  openSlideModal: () => baseEditor.value?.openSlideModal(),
  insertContent: (...args) => baseEditor.value?.insertContent(...args),
  getSlideData: () => baseEditor.value?.getSlideData(),
  isSlideAttached: () => baseEditor.value?.isSlideAttached(),
  setSlideAttachedState: (...args) =>
    baseEditor.value?.setSlideAttachedState(...args),
  getInstructionalMaterials: () =>
    baseEditor.value?.getInstructionalMaterials(),
  setInstructionalMaterials: (...args) =>
    baseEditor.value?.setInstructionalMaterials(...args),
});
</script>
